module.exports = __webpack_public_path__ + "thumbnail-55a22f37f955e373e11f47e0eabc5de6.png";